import groupBy from 'lodash/groupBy';

import { AdditionalInformationDto } from '@savgroup-front-common/types';

import { sortBy } from '../../../helpers';
import { INDEXING_STRATEGIES } from '../AdditionalInformation.types';
import { indexNeededInformation } from '../helpers/indexNeededInformation';

export interface AdditionalInformation extends AdditionalInformationDto {
  internalId: string;
  fileUploadEndpoints?: {
    [key: string]: {
      uploadEndpoint: string;
      deleteEndpoint: string;
    };
  };
}

interface UseAdditionalInformationArgs {
  neededInformation: AdditionalInformation[];
  ignoreUniquenessByProduct?: boolean;
}

const useAdditionalInformation = ({
  neededInformation,
  ignoreUniquenessByProduct,
}: UseAdditionalInformationArgs) => {
  const { indexedNeededInformation } = neededInformation
    .sort(sortBy({ fieldName: 'displayOrder' }))
    .reduce<{
      counter: number;
      previousIsGrouped?: boolean;
      indexedNeededInformation: (AdditionalInformation & {
        index?: number;
        isEven: boolean;
      })[];
    }>(
      indexNeededInformation({
        strategy: ignoreUniquenessByProduct
          ? INDEXING_STRATEGIES.WITHOUT_UNIQUENESS_BY_PRODUCT
          : INDEXING_STRATEGIES.WITH_UNIQUENESS_BY_PRODUCT,
      }),
      {
        indexedNeededInformation: [],
        previousIsGrouped: false,
        counter: 0,
      },
    );

  const neededInformationGroupedById = groupBy(
    indexedNeededInformation,
    ({ id }) => id,
  );
  const neededInformationGroupedByIdValues = Object.entries(
    neededInformationGroupedById,
  );

  return {
    neededInformationGroupedByIdValues,
  };
};

export default useAdditionalInformation;
